import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { RegistrationService } from 'core/http/lg-logistic-rest-api/Auth/registration.service';
import { LanguageService } from 'core/services/language.service';
import { environment } from 'environments/environment';
import { ObserverFactory } from 'shared/common/observers';

@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.component.html',
  styleUrls: ['./forgot.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ForgotComponent {
  forgotForm = new UntypedFormGroup({
    email: new UntypedFormControl(
      '',
      Validators.compose([
        Validators.required,
        Validators.email,
      ]),
    ),
  });

  constructor(
    private router: Router,
    private languageService: LanguageService,
    private registrationService: RegistrationService,
    private observer: ObserverFactory,
  ) {}

  sendRecovery(): void {
    if (!this.forgotForm.valid) {
      return;
    }

    const input = {
      redirectUrl: environment.FORGOT_URL,
      email: this.forgotForm.value.email,
      locale: this.languageService.currentLanguage,
    };

    this.registrationService.sendRecovery(input).subscribe(
      this.observer.withHook({
        successMsg: 'NOTIFICATIONS.recovery_email_sent',
        onSuccess: () => {
          this.router.navigate(['/', 'auth', 'login']);
        },
      }),
    );
  }
}
